import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const OuterContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  align-self: center;
  margin: 0.25rem 0;
  width: 100%;
  text-align: center;
`;

const BubbleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0.5rem 0.75rem;
  background: rgba(228, 220, 248, 0.2);
  border-radius: 8px;
  width: 100%;
`;

const MessageText = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: #413958;
`;

const ChatInfoMessage = ({ message }) => (
  <OuterContainer>
    <BubbleContainer>
      <MessageText>{message}</MessageText>
    </BubbleContainer>
  </OuterContainer>
);

ChatInfoMessage.propTypes = {
  message: PropTypes.string,
};

export default ChatInfoMessage;
